/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_TitleInputs */

const en_home_hero_title = /** @type {(inputs: Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The JSON toolkit that never sees your data.`)
};

const ko_home_hero_title = /** @type {(inputs: Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`당신의 데이터를 절대 보지 않는 JSON 도구 모음`)
};

const ja_home_hero_title = /** @type {(inputs: Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのデータを一切見ない JSON ツール`)
};

/**
* | output |
* | --- |
* | "The JSON toolkit that never sees your data." |
*
* @param {Home_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const home_hero_title = /** @type {((inputs?: Home_Hero_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_title(inputs)
	if (locale === "ko") return ko_home_hero_title(inputs)
	return ja_home_hero_title(inputs)
});